import Checkmark from '@ux/icon/checkmark';
import Info from '@ux/icon/information';
import Comment from '@ux/icon/comment';
import Alert from '@ux/icon/alert';
import Help from '@ux/icon/help';
import Star from '@ux/icon/star-outline';

/**
 * Type to icon mapping. Can be extended with more types if needed.
 *
 * @type {Object}
 * @public
 */
export const ICONS = {
  highlight: Star,
  success: Checkmark,
  info: Info,
  warning: Alert,
  critical: Alert,
  neutral: Help,
  internal: Comment
};
